module.exports = __webpack_public_path__ + "img/search.8d043558.svg";